import { BulkUserCreationRecapContentProps } from './BulkUserCreationRecap.decl';

import { Flex, Typography } from '@aircall/tractor-v2';
import { Gap } from '@dashboard/library';

export function BulkUserCreationRecapContent({
  title,
  image,
  children,
}: BulkUserCreationRecapContentProps) {
  return (
    <Flex
      data-test='bulk-user-creation-recap-content'
      flex='1'
      padding='s'
      flexDirection='column'
      gap='l'
      justifyContent='center'
      alignItems='center'
    >
      {image}
      <Gap flexDirection='column' gap='s' alignItems='center'>
        <Typography variant='headingBoldXS'>{title}</Typography>
        <Typography variant='bodyRegularS' color='neutral-500' lineHeight='24px'>
          {children}
        </Typography>
      </Gap>
    </Flex>
  );
}
